import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = {
  id: "assign-fund-form",
  class: "form assign-fund",
  method: "post"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, " Select Fund ", -1)
const _hoisted_4 = {
  key: 0,
  class: "action-buttons"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_BeneficiaryCard = _resolveComponent("BeneficiaryCard")!
  const _component_FundCard = _resolveComponent("FundCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { errors: _ctx.errors }, null, 8, ["errors"]),
    _createVNode(_component_MessageCard, {
      message: !_ctx.isAddAction? 'Note: IATSE NBF will not received your request until you click the “Assign Funds” button and proceed through the remaining steps of this form.' : 'Note that you are still in Step 2 of the form adding beneficiaries. IATSE NBF will not received your request until you click the “Assign Funds” button and proceed through the remaining steps of this form.',
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }, null, 8, ["message"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isAddAction && _ctx.newBeneficiariesCard.length)
        ? (_openBlock(), _createBlock(_component_BeneficiaryCard, {
            key: 0,
            title: "Beneficiary",
            mode: "multiple",
            data: _ctx.newBeneficiariesCard,
            deleteItem: true,
            hasDivider: true,
            customClass: "green-card beneficiary-card",
            onDelete: _ctx.deleteItem,
            onEdit: _ctx.editItem
          }, null, 8, ["data", "onDelete", "onEdit"]))
        : _createCommentVNode("", true),
      _createElementVNode("form", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.funds, (fund, key) => {
          return (_openBlock(), _createBlock(_component_FundCard, {
            title: fund,
            key: key,
            onShowButtons: _ctx.handleShowButtons
          }, null, 8, ["title", "onShowButtons"]))
        }), 128)),
        (_ctx.showActionButtons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "btn btn-primary plan-modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"])),
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.saveButtonText), 9, _hoisted_5),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetAssignments && _ctx.resetAssignments(...args)), ["prevent"])),
                class: "btn btn-secondary",
                disabled: _ctx.loading
              }, " Discard ", 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}